import { useFormState } from "react-hook-form";
export const useHasErrors = ()=>{
    const { isDirty , isValid , errors  } = useFormState();
    return isDirty && !isValid && Object.keys(errors).length > 0;
};
export default useHasErrors;

//# sourceMappingURL=useHasErrors.js.map